import { FC, memo, useMemo } from 'react'
import { Box, Flex, Icon, Stack, Text } from '@chakra-ui/react'
import Link from 'next/link'

import { Notification } from 'types'
import { CitizenProfileModuleBrand, Id } from 'components'
import { formatDateToString, formatHourToString } from 'utils/transforms/date'
import { CITIZEN_PROFILE_ROUTES } from 'CitizenProfile/constants/routes'
import getAssets from 'utils/assets/getAssets'

type Props = {
  notification: Notification
  setNotificationAsReaded: () => Promise<void>
}

const NotificationNewOriginPerson: FC<Props> = ({ notification, setNotificationAsReaded }) => {
  const GenderIcon = getAssets('Gender', notification.unified_person_sex as string)
  console.log('notification', notification)
  const pathToCitizenProfileOnOrigins = useMemo(() => {
    return {
      pathname: CITIZEN_PROFILE_ROUTES.CITIZEN_PROFILE_GENERAL.ORIGIN_REGISTERS.replace(
        '[citizenSlug]',
        notification.unified_person_slug as string
      ),
      query: { citienOriginSlug: notification.origin_person_slug as string },
    }
  }, [])
  return (
    <Link href={pathToCitizenProfileOnOrigins} target="_blank">
      <Flex
        className="accessible"
        rounded="none"
        position="relative"
        align="center"
        gap={4}
        py={2}
        px={4}
        _hover={{ bg: 'lightPrimary' }}
        onClick={setNotificationAsReaded}
      >
        <CitizenProfileModuleBrand />

        <Stack spacing={1}>
          <Flex align="center" gap={1}>
            <Id id={notification.origin_person_system_id} />
            <Text>Nova pessoa origem: {notification.origin_person_system_name}</Text>
            <Icon boxSize={4} as={GenderIcon} />
          </Flex>

          <Flex align="center" gap={1}>
            <Text variant="secondary" fontSize="xs">
              Criado em:
            </Text>
            <Text variant="secondary" fontSize="xs">
              {formatDateToString(notification.origin_person_system_created_at)} ás{' '}
              {formatHourToString(notification.origin_person_system_created_at)}
            </Text>
          </Flex>
        </Stack>

        {!notification.opened_at && <Box position="absolute" top={3} right={4} bg="success" height="10px" width="10px" rounded="full" />}
      </Flex>
    </Link>
  )
}

export default memo(NotificationNewOriginPerson)
